import API from "./axios";

interface LoginPayload {
	email: string;
	password: string;
}

export const login = async (payload: LoginPayload) => {
	const response = await API.post("/auth/login", payload);
	return response.data;
};